module.exports = "<span (click)='switch()'\n    [class.selected]=\"isSelected\">\n  {{label}}\n</span>\n"


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/tag-page/tag-page.component.html
// module id = ../../../../../src/app/tag-page/tag-page.component.html
// module chunks = main